var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "app-container",
      attrs: { "element-loading-text": "加载中..." },
    },
    [
      _c(
        "el-card",
        {
          staticClass: "sticky-container",
          attrs: { shadow: "never", "body-style": { padding: 0 } },
        },
        [
          _c(
            "template",
            { slot: "header" },
            [
              _c(
                "el-form",
                { attrs: { inline: "", model: _vm.queryParams } },
                [
                  _c(
                    "el-form-item",
                    { staticStyle: { "margin-bottom": "0" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "轮播图位置", clearable: "" },
                          model: {
                            value: _vm.queryParams.position,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "position", $$v)
                            },
                            expression: "queryParams.position",
                          },
                        },
                        _vm._l(_vm.position, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticStyle: { "margin-bottom": "0" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "状态", clearable: "" },
                          model: {
                            value: _vm.queryParams.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "status", $$v)
                            },
                            expression: "queryParams.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "已禁用", value: "0" },
                          }),
                          _c("el-option", {
                            attrs: { label: "已启用", value: "1" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticStyle: { "margin-bottom": "0" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", icon: "el-icon-search" },
                          on: { click: _vm.handleFilter },
                        },
                        [_vm._v("查找")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { type: "danger", icon: "el-icon-edit" },
                          on: { click: _vm.handleCreate },
                        },
                        [_vm._v("新增轮播图")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                { name: "sticky-header", rawName: "v-sticky-header" },
              ],
              attrs: {
                fit: "",
                "highlight-current-row": "",
                border: "",
                data: _vm.list,
                "header-cell-class-name": "table-header-cell style1",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  width: "60",
                  align: "center",
                  type: "index",
                  "class-name": "table-header-cell style1",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.$index +
                                1 +
                                (_vm.queryParams.page - 1) *
                                  _vm.queryParams.limit
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "轮播图位置",
                  prop: "bannerPosition",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm._f("positionTag")(row.bannerPosition),
                              effect: "dark",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm._f("positionName")(row.bannerPosition))
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "轮播图图片",
                  prop: "cover",
                  width: "100",
                  align: "center",
                  "class-name": "image-col",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("el-image", {
                          attrs: {
                            src: row.cover,
                            "preview-src-list": [row.cover],
                            lazy: "",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "背景颜色",
                  prop: "backgroundColor",
                  width: "80",
                  "class-name": "name-col",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", {
                          staticClass: "span-color",
                          style: { backgroundColor: row.backgroundColor },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "跳转路径",
                  prop: "redirectTo",
                  "class-name": "name-col",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(_vm._s(_vm.getAppMenuName(row.redirectTo))),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "排序",
                  prop: "sortBy",
                  align: "center",
                  width: "60",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "状态",
                  prop: "status",
                  width: "80",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("el-switch", {
                          staticClass: "rectangle md",
                          attrs: { "active-value": 1, "inactive-value": 0 },
                          on: {
                            change: function ($event) {
                              return _vm.handleUpdate(row)
                            },
                          },
                          model: {
                            value: row.status,
                            callback: function ($$v) {
                              _vm.$set(row, "status", $$v)
                            },
                            expression: "row.status",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", width: "80", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-dropdown",
                          { attrs: { trigger: "click" } },
                          [
                            _c("span", { staticClass: "el-dropdown-link" }, [
                              _vm._v(" 操作"),
                              _c("i", {
                                staticClass:
                                  "el-icon-arrow-down el-icon--right",
                              }),
                            ]),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.handleEdit(row)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-edit" }),
                                    _vm._v(" 修改轮播图"),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: { divided: "" },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.handleRemove(row)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-delete" }),
                                    _vm._v(" 删除轮播图"),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("pagination", {
            attrs: {
              total: _vm.total,
              page: _vm.queryParams.page,
              limit: _vm.queryParams.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.queryParams, "limit", $event)
              },
              pagination: _vm.loadData,
            },
          }),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "编辑轮播图",
            width: "750px",
            visible: _vm.dialogVisible,
            "append-to-body": "",
            fullscreen: _vm.device === "mobile",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.dialogClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "detailForm",
              attrs: {
                model: _vm.detail,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "inline-form-item",
                          attrs: { label: "轮播图位置" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择轮播图位置" },
                              model: {
                                value: _vm.detail.bannerPosition,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detail, "bannerPosition", $$v)
                                },
                                expression: "detail.bannerPosition",
                              },
                            },
                            _vm._l(_vm.position, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 12, sm: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "inline-form-item",
                          attrs: { label: "背景颜色" },
                        },
                        [
                          _c("el-color-picker", {
                            model: {
                              value: _vm.detail.backgroundColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.detail, "backgroundColor", $$v)
                              },
                              expression: "detail.backgroundColor",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 12, sm: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "inline-form-item",
                          attrs: { label: "排序" },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入排序" },
                            model: {
                              value: _vm.detail.sortBy,
                              callback: function ($$v) {
                                _vm.$set(_vm.detail, "sortBy", $$v)
                              },
                              expression: "detail.sortBy",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "轮播图", prop: "cover" } },
                        [
                          _c(
                            "div",
                            { staticClass: "image-uploader" },
                            [
                              _c(
                                "el-upload",
                                {
                                  staticClass: "avatar-uploader",
                                  attrs: {
                                    action: "#",
                                    accept: "image/*",
                                    "show-file-list": false,
                                    "on-change": _vm.imageChange,
                                    "http-request": _vm.imageUpload,
                                  },
                                },
                                [
                                  _vm.coverImage && _vm.coverImage.url
                                    ? [
                                        _c("img", {
                                          staticClass: "avatar",
                                          attrs: { src: _vm.coverImage.url },
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "el-upload-img-actions",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-upload-img-preview",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.imagePreview.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-zoom-in",
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-upload-img-delete",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.imageBeforeRemove.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-delete",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _c("i", {
                                        staticClass:
                                          "el-icon-plus avatar-uploader-icon",
                                      }),
                                ],
                                2
                              ),
                              _c("el-image", {
                                ref: "elImage",
                                staticStyle: { width: "0", height: "0" },
                                attrs: {
                                  src: _vm.coverImage.url,
                                  "preview-src-list": [_vm.coverImage.url],
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "inline-form-item",
                          attrs: { label: "状态", prop: "status" },
                        },
                        [
                          _c("el-switch", {
                            staticClass: "rectangle",
                            attrs: {
                              width: 60,
                              "active-color": "#13ce66",
                              "active-value": 1,
                              "inactive-value": 0,
                            },
                            model: {
                              value: _vm.detail.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.detail, "status", $$v)
                              },
                              expression: "detail.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "inline-form-item",
                          attrs: { label: "跳转路径", prop: "redirectTo" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择跳转路径",
                                clearable: "",
                              },
                              model: {
                                value: _vm.detail.redirectTo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detail, "redirectTo", $$v)
                                },
                                expression: "detail.redirectTo",
                              },
                            },
                            _vm._l(_vm.appMenus, function (item, index) {
                              return _c(
                                "el-option",
                                {
                                  key: index,
                                  attrs: {
                                    label: item.menuName,
                                    value: item.menuLink,
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { float: "left" } },
                                    [_vm._v(_vm._s(item.menuName))]
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { float: "right" } },
                                    [_vm._v(_vm._s(item.menuLink))]
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.dialogClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }